/* Lumeris : ouverture fluide des questions (FAQ) et des onglets produit, icône + qui devient − */
(function(){
  if(window.lmAccInit)return;window.lmAccInit=true;
  var DUR=450,EASE='cubic-bezier(.65,0,.35,1)';

  function prepare(){
    document.querySelectorAll('.product__accordion details:not(.lm-acc)').forEach(function(d){
      var sum=d.querySelector(':scope>summary'),c=d.querySelector(':scope>.accordion__content');
      if(!sum||!c)return;
      d.classList.add('lm-acc');
      if(!sum.querySelector('.lm-q__ic')){var i=document.createElement('i');i.className='lm-q__ic';i.setAttribute('aria-hidden','true');sum.appendChild(i);}
      var w=document.createElement('div');w.className='lm-q__a';c.parentNode.insertBefore(w,c);w.appendChild(c);
      if(d.open)d.classList.add('is-open');
    });
    document.querySelectorAll('details.lm-q[open]').forEach(function(d){d.classList.add('is-open');});
    snap();
  }

  /* traits calés sur les pixels de l'écran : même épaisseur sur chaque ligne */
  function snap(){
    var dpr=window.devicePixelRatio||1;
    document.querySelectorAll('.lm-q__ic').forEach(function(ic){
      ic.style.translate='0px 0px';
      var r=ic.getBoundingClientRect();
      var x=(r.left+window.scrollX)*dpr,y=(r.top+window.scrollY)*dpr;
      ic.style.translate=((Math.round(x)-x)/dpr)+'px '+((Math.round(y)-y)/dpr)+'px';
    });
  }
  window.lmAccSnap=snap;

  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',prepare);else prepare();
  window.addEventListener('load',snap);
  window.addEventListener('resize',snap);
  if(document.fonts&&document.fonts.ready)document.fonts.ready.then(snap);
  if(window.ResizeObserver){var ro=new ResizeObserver(function(){snap();});var obs=function(){ro.observe(document.body);};if(document.body)obs();else document.addEventListener('DOMContentLoaded',obs);}
  document.addEventListener('shopify:section:load',prepare);

  document.addEventListener('click',function(e){
    var sum=e.target.closest('details.lm-q>summary, details.lm-acc>summary');
    if(!sum)return;
    var d=sum.parentNode,a=d.querySelector(':scope>.lm-q__a');
    if(!a||!a.animate)return;
    e.preventDefault();
    var from=d.open?a.getBoundingClientRect().height:0;
    if(d._anim){d._anim.cancel();d._anim=null;}
    if(!d.classList.contains('is-open')){
      d.classList.add('is-open');d.open=true;sum.setAttribute('aria-expanded','true');
      var h=a.scrollHeight;
      d._anim=a.animate([{height:from+'px',opacity:from?1:0},{height:h+'px',opacity:1}],{duration:DUR,easing:EASE});
      d._anim.onfinish=function(){d._anim=null;snap();};
    }else{
      d.classList.remove('is-open');sum.setAttribute('aria-expanded','false');
      var fin=function(){if(d.classList.contains('is-open'))return;d.open=false;if(d._anim){d._anim.cancel();d._anim=null;}snap();};
      d._anim=a.animate([{height:from+'px',opacity:1},{height:'0px',opacity:0}],{duration:DUR,easing:EASE,fill:'forwards'});
      d._anim.onfinish=fin;
      setTimeout(fin,DUR+80);
    }
  });
})();

/* Lumeris : la miniature sélectionnée se recentre toujours dans la bande de miniatures */
(function(){
  if(window.lmThumbInit)return;window.lmThumbInit=true;
  function center(thumb,smooth){
    var item=thumb.closest('.thumbnail-list__item')||thumb;
    var list=item.closest('.thumbnail-list');
    if(!list||list.scrollWidth<=list.clientWidth+1)return;
    var lr=list.getBoundingClientRect(),ir=item.getBoundingClientRect();
    var target=list.scrollLeft+(ir.left-lr.left)-(list.clientWidth-ir.width)/2;
    target=Math.max(0,Math.min(target,list.scrollWidth-list.clientWidth));
    list.scrollTo({left:target,behavior:smooth?'smooth':'auto'});
  }
  function later(thumb){
    /* après le défilement propre au thème, pour avoir le dernier mot */
    clearTimeout(window.lmThumbT);
    window.lmThumbT=setTimeout(function(){center(thumb,true);},60);
  }
  var mo=new MutationObserver(function(muts){
    for(var i=0;i<muts.length;i++){
      var t=muts[i].target;
      if(t.classList&&t.classList.contains('thumbnail')&&t.getAttribute('aria-current')==='true'){later(t);return;}
    }
  });
  function start(){
    mo.observe(document.body,{subtree:true,attributes:true,attributeFilter:['aria-current']});
    var cur=document.querySelector('.thumbnail[aria-current="true"]');
    if(cur)center(cur,false);
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',start);else start();
  document.addEventListener('click',function(e){
    var th=e.target.closest('.thumbnail');
    if(th)later(th);
  });
})();
